import * as apiSW from 'api/ingredient/GetIngredientStartingWithV1';
import { Optional } from 'functions/promiseExtensions';
import * as Ingredient from 'types/_general/Store/Ingredient';

export type Type = Ingredient.Type[];

export function create(): Type {
	return [];
}

export async function getFromApi(): Promise<Type> {
	const response = await apiSW.callApi('', false);
	const output = response.getOrDefault([]);
	return output.map((e) => Ingredient.mapFromApi(e));
}

export function getNameById(obj: Type, id: string): string {
	return Optional.Maybe(obj.find((e) => e.id === id))
		.map((e) => e.name)
		.getOrDefault('');
}

export function getById(obj: Type, id: string): Ingredient.Type | undefined {
	return obj.find((e) => e.id === id);
}
